import React from 'react';
import './Videodetail.scss';
import Rightbar from "../../components/Rightbar/Rightbar";
import Globals from "../../api";
import ReactHtmlParser from 'react-html-parser';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';


export default class VideoDetailPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          videoDetail: [],
          Rightbar : [],
          AdData : []
        };
      }
      getAds(){
        const url= Globals.AdConfig;
                fetch(url)
                .then((res) => res.json())
                .then((data) => {
                  
                    this.setState({
                      AdData : data.AdContents[0].ROS
                    })
                    
                }) 
                
      } 
      getRightbar(){
        const url= Globals.Rightbar_api+"/latest-kannada-news";
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
            
            this.setState({
              Rightbar : data.Contents[0]
            })
        })   
      }    
    componentDidMount() {
        let url = window.location.pathname;
       // url = url.split("/").pop();
           //console.log("videoList",url);
        const videoListURL = Globals.language_based_api + url;
        //const videoListURL = 'http://ws-uat.webdunia.com/json/page?lang=te&url='+url;
        //console.log("videoList",videoListURL);
        fetch(videoListURL)
          .then((res) => res.json())
          .then((data) => {
            this.setState({
                videoDetail: data.Contents[2].out.Contents[1].Items,
            });
        });
        this.getRightbar();

      }
    render() {
            let videodetails = this.state.videoDetail;
            //console.log("videos", videodetails)

        return (
            <div className="container padding15">
                <div className="row">
                    <div className="col">
                        <div className="video_detai_wrap">
                            <h2 className="video_title">{videodetails.title}</h2>
                            <div className="video_wraper">

                            </div>
                            <div id="video"> 
                            {/* <iframe id="" width="100%" height="500" src={`https://www.dailymotion.com/embed/video/${videodetails.id}?autoplay=1&amp;mute=1&amp;endscreen-enable=0`} allowfullscreen="" allow="autoplay"></iframe>
                             */}
                              <LiteYouTubeEmbed 
              style = {{width : "250px", height : "270px" ,padding : "5px"}}
              id={videodetails.id}
              title = {videodetails.title}
              poster="hqdefault"
              webp = {true}
              params ='rel=0;'
    /> 
                            </div>
                            <p><b>{ReactHtmlParser(videodetails.description)}</b></p>
                        </div>
                        
                    </div>
                    <div className="col right_side_bar">
                    <Rightbar Rightbar={this.state.Rightbar} googleAds = {this.state.AdData}/>

                    </div>
                </div>
            </div>
        )
    }
}